import $ from "jquery";
import Isotope from "isotope-layout"; 
import 'isotope-packery';
// npm install isotope-layout
// npm install isotope-packery

$(function() {
    $(".bl-teamlist").each(function() {
        const $bl = $(this);

        $bl.find(".item").addClass("visible");
        updateNVisibility();

        const iso = new Isotope($bl.find(".ctritems").get(0), {
            layoutMode: 'packery',
            itemSelector: ".item",
            percentPosition: true, //smoother resize handling
            packery: {
                gutter: '.guttersizer',
                columnWidth: '.columnsizer'
            },
            getSortData: {
                //name: '[data-name]',
                sortbleitung: function (itemElem) {
                    return parseInt(itemElem.getAttribute('data-sortbleitung'));
                }
            }
        });

        const $filterbuttons = $bl.find(".ctrfilterbuttons");
        $filterbuttons.on("click", "a", function() {
            const $filterbutton = $(this);
            const requestedFilter = $filterbutton.data("filter");

            highlightFilterButton(requestedFilter);
            filterIsotope(requestedFilter);
        });

        function highlightFilterButton(requestedFilter) {
            $filterbuttons.find("a").removeClass("active");
            $filterbuttons.find("[data-filter='"+requestedFilter+"']").addClass("active");
        }

        function filterIsotope(requestedFilter) {
            if(requestedFilter == "*") {
                clearFilterIsotope();
                return;
            }

            let sort = "original-order";
            if(requestedFilter == "bleitung") {
                sort = "sortbleitung";
            }

            iso.arrange({
                filter: ".filter-"+requestedFilter,
                sortBy: sort,
                sortAscending: true
            });

            $bl.find(".item").removeClass("visible");
            $bl.find(".item.filter-"+requestedFilter).addClass("visible");

            updateNVisibility(sort);
        }

        function clearFilterIsotope() {
            $bl.find(".item").addClass("visible");
            iso.arrange({
                filter: "",
                sortBy: "original-order",
                sortAscending: true
            });
            updateNVisibility();
        }

        function updateNVisibility(sort) {
            $bl.find(".item").removeClass("visible2n2").removeClass("visible3n2");
            const sortedItems = $bl.find(".item.visible").toArray();
            if(sort == "sortbleitung") {
                sortedItems.sort(function(a, b) {
                    return parseInt(a.getAttribute('data-sortbleitung')) - parseInt(b.getAttribute('data-sortbleitung'));
                });
            }
            $(sortedItems).each(function(idx) {
                const $item = $(this);
                if(idx % 2 == 1) {
                    $item.addClass("visible2n2");
                }
                if(idx % 3 == 1) {
                    $item.addClass("visible3n2");
                }
            });
        }
    });
});

